<template>
  <v-container fluid style="padding: 6px 6px;">
    <v-layout row wrap>
      <v-flex xs12>
        <v-card xs12 class="hide-on-print">
          <v-card-text class="py-2 px-3">
            <v-flex xs12>
              <v-layout class="white" row wrap>
                <v-flex class="pl-3" xs6>
                  <v-text-field
                      @keypress.enter="search"
                      label="Search By Submission Number"
                      outlined
                      ref="barCodeRef"
                      type="text"
                      hide-details
                      v-model="bar_code"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex class="pl-3 pr-3 pb-0 hide-on-print" xs6>
                  <v-text-field
                      @keypress.enter="searchByVisa"
                      label="Search By Visa Number"
                      outlined
                      ref="barCodeRef"
                      type="text"
                      hide-details
                      v-model="visa_number"
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex>
              <v-progress-linear
                  class="mt-2"
                  v-if="loading && !computed_bar_code"
                  indeterminate
                  color="primary"
              ></v-progress-linear>
            </v-flex>
          </v-card-text>
        </v-card>

        <visa-detail v-if="computed_bar_code"/>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

import view from './ViewVisaRequest'
import {SET_PRINT_CONTENT, SET_PRINT_CONTENT_ONLY} from "../../../store/mutation-type";

export default {
  name: "BarCode",
  components: {
    'visa-detail': view
  },
  data() {
    return {
      bar_code: null,
      visa_number: null,
      computed_bar_code: null,
      loading: false,
    }
  },
  methods: {
    ...mapActions("VisaRequestSingle", [
      "getVisaRequestDetail", "getVisaRequestDetailByVisa"
    ]),
    search() {
      this.loading = true
      const bar_code = this.visa_number || this.bar_code;
      this.$store.commit(SET_PRINT_CONTENT_ONLY, '')

      this.getVisaRequestDetail(bar_code)
          .then(() => {
            this.computed_bar_code = bar_code;
            this.loading = false
          })
          .catch((e) => {
            if (e.response.status === 404)
              this.$store.commit("Notification/showError", "The Submission number is not found");
            this.computed_bar_code = false;
            this.loading = false
          });
    },
    searchByVisa() {
      this.loading = true
      const visa_number = this.visa_number;
      this.$store.commit(SET_PRINT_CONTENT_ONLY, '')
      this.getVisaRequestDetailByVisa(visa_number)
          .then(() => {
            this.computed_bar_code = visa_number;
            this.loading = false
          })
          .catch((e) => {
            if (e.response.status === 404)
              this.$store.commit("Notification/showError", "The Visa number is not found");
            else
              this.$store.commit("Notification/showError", "Something went wrong");
            // this.$store.commit("VisaRequestSingle/resetState");
            this.computed_bar_code = false;
            this.loading = false
          });
    },
    checkAndSearchBarCode(){
      if(this.$route.query.bar_code){
        this.bar_code = this.$route.query.bar_code
        this.search()
      }
    }
  },
  computed: {
    ...mapGetters('VisaRequestSingle', ['visaRequest', 'paid'])
  },
  mounted() {
    this.checkAndSearchBarCode();
  }
}
</script>

<style scoped>
@media print {
  .hide-on-print {
    display: none !important;
  }
}

</style>
